<form autocomplete="off" class="p-0" novalidate [formGroup]="photoSignDetailsForm">
    <div class="col-lg-12 col-md-12">
        <div class="mt-1">
            <h5 class="main-content-label fw-bold mb-1">Photo & Signature</h5>

            <div class="row g-1"> 
                <div class="col-md-4 col-sm-12">
                    <div class="card p-1 h-100"> 
                        <label class="form-label small fw-bold mb-1">Upload Photo</label>
                        <div class="upload-container">
                            <img *ngIf="!userImage"
                                 src="../../assets/images/user2.png"
                                 class="default-img" />
                            
                            <img *ngIf="userImage"
                                 [src]="userImage"
                                 class="img-preview" />
                        </div>

                        <div class="text-center mt-1" *ngIf="updateButton">
                            <input #fileUpload type="file" hidden (change)="onChange1($event)" 
                                accept=".jpg,.jpeg,.JPG,.JPEG" />
                            <button type="button"
                                    class="btn btn-sm btn-outline-primary px-2 py-1"
                                    matTooltip="JPG/JPEG • 200×230px to 500×530px • Max 50KB"
                                    (click)="fileUpload.click()"> 
                                <i class="ai-upload me-1 small"></i>Upload Photo
                            </button>
                        </div>
                    </div>
                </div>
                <!-- <div class="col-md-4 col-sm-12" [style.visibility]="is_hidephotosign ? 'visible' : 'hidden'">
                    <div class="card shadow-sm p-1 h-100">
                        <label class="form-label small fw-bold mb-1">Upload Signature</label>
                        <div class="signature-container">
                            <img *ngIf="!signatureImage"
                                 src="../../assets/images/sign.png"
                                 class="default-sign" />

                            <img *ngIf="signatureImage"
                                 [src]="signatureImage"
                                 class="img-preview" />
                        </div>

                    
                        <div class="text-center mt-1" *ngIf="updateButton">
                            <input #fileUpload2 type="file" hidden (change)="onChangeSign($event)" 
                                accept=".jpg,.jpeg,.JPG,.JPEG" /> 
                            <button type="button"
                                    class="btn btn-sm btn-outline-primary px-2 py-1"
                                    matTooltip="JPG/JPEG • 140×60px to 300×300px • Max 20KB"
                                    (click)="fileUpload2.click()"> 
                                <i class="ai-upload me-1 small"></i>Upload Signature
                            </button>
                        </div>
                    </div>
                </div> -->
                <div class="col-md-4 col-sm-6">
                    <div class="card shadow-sm p-1 h-100">
                          <div class="requirements-box">
                            <div class="fw-bold">Photo Requirements</div>
                            <div>• JPG/JPEG • Max 50KB</div>
                            <div>• 200 x 230 pixels</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-6">
                     <div class="card shadow-sm p-1 h-100">
                        <label class="form-label small fw-bold mb-1">
                            ABC Id <span class="redCol">*</span>
                        </label>
                        
                        <mat-form-field appearance="outline" class="w-100 small mb-1">
                            <input required maxlength="12"
                                   matInput
                                   formControlName="StuABCId2"
                                   placeholder="Enter ABC Id">
                        </mat-form-field>
                        <mat-error *ngIf="isInvalid('StuABCId2', 'required')">
                            ABC ID is required
                        </mat-error>
                        <mat-error *ngIf="isInvalid('StuABCId2', 'pattern')">
                            ABC ID must be 12 characters
                        </mat-error>


                         <label class="form-label small fw-bold mb-1 mt-1">
                            Birth Date <span class="redCol">*</span>
                        </label>

                        <mat-form-field appearance="outline" class="w-100 small">
                            <input matInput
                                type="date"
                                formControlName="BirthDate"
                                [max]="TODAY_DATE">
                        </mat-form-field>

                        <mat-error *ngIf="isInvalid('BirthDate', 'required')">
                            Birth date is required
                        </mat-error>
                    </div> 
                </div>
                <div class="col-md-4 col-sm-12">
                    <div class="card shadow-sm p-1 h-100">
                        <label class="form-label small fw-bold mb-1">
                            Name in Marathi <span class="redCol">*</span>
                        </label>
                        <mat-form-field appearance="outline" class="w-100 small">
                            <input matInput
                                formControlName="NameInMarathi"
                                placeholder="मराठी नाव लिहा"
                                maxlength="100">
                        </mat-form-field>
                        <mat-error *ngIf="isInvalid('NameInMarathi', 'required')">
                            Name in Marathi is required
                        </mat-error>
                        <mat-error *ngIf="isInvalid('NameInMarathi')">
                            Only Marathi characters are allowed
                        </mat-error>
                    </div>
                </div>
                <div class="col-md-4 col-sm-12">
                    <div class="card shadow-sm p-1 h-100">
                        <label class="form-label small fw-bold mb-1">Aadhar Number</label>
                        <mat-form-field appearance="outline" class="w-100 small">
                            <input matInput
                                type="text"
                                formControlName="AdharNo"
                                placeholder="Enter Aadhar Number"
                                maxlength="12">
                        </mat-form-field>
                          <mat-error *ngIf="isInvalid('AdharNo', 'required')">
                            Aadhaar number is required
                        </mat-error>
                        <mat-error *ngIf="isInvalid('AdharNo' )">
                            Enter a valid 12-digit Aadhaar number
                        </mat-error>
                        
                    </div>
                </div>
                <div class="col-md-4 col-sm-12">
                    <div class="card shadow-sm p-1 h-100">
                        <label class="form-label small fw-bold mb-1">Mobile Number</label>
                        <mat-form-field appearance="outline" class="w-100 small">
                            <input matInput
                                type="tel"
                                formControlName="MobNo"
                                placeholder="Enter Mobile Number"
                                maxlength="10">
                        </mat-form-field>
                        <mat-error *ngIf="isInvalid('MobNo', 'required')">
                            Mobile number is required
                        </mat-error>
                        <mat-error *ngIf="isInvalid('MobNo')">
                            Enter a valid 10-digit mobile number
                        </mat-error>
                    </div>
                </div>
                <div class="col-md-4 col-sm-12">
                    <div class="card shadow-sm p-1 h-100">
                        <label class="form-label small fw-bold mb-1">Email Address</label>
                        <mat-form-field appearance="outline" class="w-100 small">
                            <input matInput
                                type="email"
                                formControlName="Email"
                                placeholder="Enter Email Address">
                        </mat-form-field>
                         <mat-error *ngIf="isInvalid('Email', 'required')">
                            Email address is required
                        </mat-error>
                        <mat-error *ngIf="isInvalid('Email', 'pattern')">
                            Enter a valid email address (e.g., name@example.com)
                        </mat-error>
                    </div>
                </div>

                <div class="col-md-4 col-sm-12" style="display: none;">
                    <div class="card shadow-sm p-1 h-100">
                        <label class="form-label small fw-bold mb-1">Internship Status</label>
                        <div class="mt-1 d-flex align-items-center">
                            <mat-checkbox formControlName="is_internship" class="me-1 small">
                                Completed
                            </mat-checkbox>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-sm-12">
                    <div class="card shadow-sm p-1 h-100">
                        <label class="form-label small fw-bold mb-1">
                            Internship From
                            <span *ngIf="photoSignDetailsForm.get('is_internship')?.value" class="redCol">*</span>
                        </label>
                        <mat-form-field appearance="outline" class="w-100 small">
                           <input matInput
                                type="date"
                                formControlName="InternshipFrom"
                                [min]="INTERNSHIP_MIN_DATE | date:'yyyy-MM-dd'"
                                [max]="INTERNSHIP_MAX_DATE | date:'yyyy-MM-dd'">

                        </mat-form-field>
                        <mat-error *ngIf="isInvalid('InternshipFrom', 'required')">
                            Internship start date is required
                        </mat-error>
                        <mat-error *ngIf="isInvalid('InternshipFrom', 'min')">
                            Date cannot be before {{ INTERNSHIP_MIN_DATE | date:'dd/MM/yyyy' }}
                        </mat-error>
                        <mat-error *ngIf="isInvalid('InternshipFrom', 'max')">
                            Date cannot be after {{ INTERNSHIP_MAX_DATE | date:'dd/MM/yyyy' }}
                        </mat-error>
                    </div>
                </div>
                <div class="col-md-4 col-sm-12">
                    <div class="card shadow-sm p-1 h-100">
                        <label class="form-label small fw-bold mb-1">
                            Internship To
                            <span *ngIf="photoSignDetailsForm.get('is_internship')?.value" class="redCol">*</span>
                        </label>
                        <mat-form-field appearance="outline" class="w-100 small">
                            <input matInput
                                type="date"
                                formControlName="InternshipTo"
                                [min]="INTERNSHIP_MIN_DATE | date:'yyyy-MM-dd'"
                                [max]="INTERNSHIP_MAX_DATE | date:'yyyy-MM-dd'">
                        </mat-form-field>
                        <mat-error *ngIf="isInvalid('InternshipTo', 'required')">
                            Internship end date is required
                        </mat-error>
                        <mat-error *ngIf="isInvalid('InternshipTo', 'min')">
                            Date cannot be before {{ INTERNSHIP_MIN_DATE | date:'dd/MM/yyyy' }}
                        </mat-error>
                        <mat-error *ngIf="isInvalid('InternshipTo', 'max')">
                            Date cannot be after {{ INTERNSHIP_MAX_DATE | date:'dd/MM/yyyy' }}
                        </mat-error>
                        <mat-error *ngIf="isInvalid('InternshipTo', 'dateRange')">
                            End date must be after start date
                        </mat-error>
                    </div>
                </div>

            </div>

            <div class="button-container d-flex justify-content-end">
                <button id="Back"
                        type="button"
                        [mat-dialog-close]="true"
                        class="btn btn-sm btn-outline-secondary px-2 py-1 me-1">
                    <i class="ai-arrow-left me-1 small"></i>Back
                </button>

                <button *ngIf="updateButton"
                        type="button"
                        [disabled]="disabled || isSaving"
                        (click)="updateCheck()"
                        class="btn btn-sm btn-primary px-2 py-1">
                    <i class="ai-save me-1 small"></i>
                    <span *ngIf="!isSaving">Update</span>
                    <span *ngIf="isSaving">Saving...</span>
                </button>
            </div>

        </div>
    </div>
</form>